import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 191.92 140"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m157.48 86.61 17.98 22.46 16.46-13.76-17.98-22.46-16.46 13.76Z",
      style: {"fill":"#21b9da"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M41.18 49.21C33.8 43.83 23.4 33.92 19.05 29.46L0 51.12C10.21 64.04 28.8 76.06 35.31 79.6c-.1-11.16 2.49-21.84 5.86-30.38ZM152.26 90.8s-21.98 20.42-44.54 20.42c-26.66 0-34.22-18.98-35.52-22.78C64.53 66.1 84.78 39.82 98.26 32.7c5.5-2.91 13.26-5.83 19.14-2.7.2.1 2.53 1.49-1.14 8.1-2.35 4.23-14.35 20.35-34.81 23.62-6.79 14.51-3.48 24.26-.73 28.94 14.7-1.07 28.6-6.69 41.41-16.74l.3-.24c11.28-9.38 29.33-28.37 23.47-50.09-3.27-12.12-13.34-20.72-26.95-23.01-17.28-2.9-43.02 4.53-63.11 34.28-12.17 16.21-31.38 72.29 22.46 99.17 48.4 21.15 91.67-20.65 91.67-20.65l-17.7-22.58Z",
      style: {"fill":"#702b91"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "UO-logo"}) } }